import Action from '../Action'
import './styles/ModalCreateCis.css'
import { useState ,useEffect} from 'react';
import LoadSimple from '../LoadSimple';
import InputAdmin from '../InputAdmin';
import { useFetch } from '../../hooks/useFetch';
import SelectorAdmin from '../SelectorAdmin';
import { lang } from '../generales/traduction';
import { capitalizeFirstLetter } from '../../utils/utils';
const ModalCreateCis =({user,languaje,mode,devices,server,setRegisterIsValid,dataCis,setData,loading,setLoading,setError,setEditActive,editActive,closCreateCisModal,handleShowPopup})=>{
    const obtenerFechaActualLocal = () => {
        const ahora = new Date();
        const anio = ahora.getFullYear();
        const mes = String(ahora.getMonth() + 1).padStart(2, '0'); // El mes se cuenta desde 0
        const dia = String(ahora.getDate()).padStart(2, '0');
        const horas = String(ahora.getHours()).padStart(2, '0');
        const minutos = String(ahora.getMinutes()).padStart(2, '0');
      
        return `${anio}-${mes}-${dia}T${horas}:${minutos}`;
      };
    const [loadingM,setLoadingM]=useState(false);
    const [IpValid,setIpValid]=useState(true)
    const [matchPassword,setMatchPassword]=useState(false)
    const [disabled,setDisabled]=useState(true)
    const [host,sethost]=useState([])
    const [cisData,setCisData]=useState({software_name:'',message:''})
    const [hostName,setHostName]=useState("")
    const [hostLocation,setHostLocation]=useState("")
    const [hostActivate,setHostActivate]=useState(0)
    const tec_list=useFetch('cassia/ci_elements/technologies','','','GET',server)
    const [msgError,setMsgError]=useState("")
    const [listSearchIP,setListSearchIP]=useState(false)
    //     console.log(host)
    useEffect(()=>{
    //    console.log("cambio host")
       if(host.length>=1){
           setHostName(host[0].name)
           setHostLocation(host[0].location)
           setHostActivate(host[0].status)
           setCisData((prevState)=>{
               return {
                   ...prevState,
                   ['location']:host[0].location
               }
               
           })
           setCisData((prevState)=>{
               return {
                   ...prevState,
                   ['host_id']:host[0].hostid
               }
               
           })
           setCisData((prevState)=>{
               return {
                   ...prevState,
                   ['status']:(host[0].status!=0)?capitalizeFirstLetter(lang[languaje]['activo']):capitalizeFirstLetter(lang[languaje]['inactivo'])
               }
               
           })
       }else{
           setHostName("")
           setCisData((prevState)=>{
               return {
                   ...prevState,
                   ['host_id']:0
               }
               
           })
           // setCisData((prevState)=>{
           //     return {
           //         ...prevState,
           //         ['device_name']:""
           //     }

           // })
       }
  },[host])

    const handleChange=(e)=>{
        const {name,value}=e.target
        if(e.target.name==="criticality"){
            setCisData((prevState)=>{
                return {
                    ...prevState,
                    [name]:value===""?0:(parseInt(value))
                }
                
            })
        }  else if(e.target.name==="status"){
            setCisData((prevState)=>{
                return {
                    ...prevState,
                    [name]:(value=="Inactivo")?capitalizeFirstLetter(lang[languaje]['activo']):capitalizeFirstLetter(lang[languaje]['inactivo'])
                }
                
            })
        }else{
            setCisData((prevState)=>{
                return {
                    ...prevState,
                    [name]:value
                }
                
            })
        }



        if(e.target.name==="ip"){
            if(value==""){
                setHostLocation("")
                setHostActivate(0)
                setIpValid(true)
                sethost([])
                setHostName("")
                setHostLocation("")
            }else{
                setIpValid(validateIp(value))
            }
           
           
          }
    }

    useEffect(()=>{
     
          if(  cisData.software_name==="" || cisData.message==="" ){
              setDisabled(true)
          }else{
              setDisabled(false)
          }
    },[cisData])


    const Registrar=()=>{
        let method='POST'
        let url_add=''
        if(editActive){
            method='PUT'
            url_add=dataCis.element_id
        }

        setLoading(true)
        const fetchDataPost = async () => {
          
       try {
           // console.log(localStorage.getItem('access_token'))
           const response = await fetch(server.url+'/api/v1/cassia/request_new_software/', {
             method: 'POST',  
             headers: {
                 'Content-Type': 'application/json',
                 Authorization: `Bearer ${localStorage.getItem('access_token')}`,
               },
             body: JSON.stringify(cisData),
           });
           if (response.ok) {
             
             const data1 = await response.json();
             setLoading(false)
             // Manejo de la respuesta
             setData(data1)
             // console.log(data1);
             handleShowPopup(capitalizeFirstLetter(lang[languaje]['completado']),'Solicitud de software generada correctamente','', true)
             closCreateCisModal()
         //   setRegisterIsValid(true)
           
           
         
           } else {
             handleShowPopup('ERROR!!!','Solicitud de software no se genero correctamente','Favor de reportarlo', false)
             throw new Error('Error en la solicitud');
           }
       } catch (error) {
              setHostName("")
              setCisData({ip:"",host_id:0,date:"",responsible_name:"",auth_name:"",device_description:"",justification:"",previous_state:"",new_state:"",impact:"",result:"",observations:"",files:[],status:'Activo'})
              
          setLoading(false)
            // Manejo de errores
            setError(error)
            closCreateCisModal()
          //   setRegisterIsValid(true)
            
            
          }
        };

        fetchDataPost();
    }
    useEffect(()=>{
        if(editActive){
            buscar_host(dataCis.ip)
        }
    },[])
    const buscar_host=(ip)=>{
        setLoadingM(true)
        const fetchDataPost = async () => {
          
       try {
           const response = await fetch(server.url+'/api/v1/cassia/ci_elements/search_host/'+ip, {
               method: 'GET',  
               headers: {
                 'Content-Type': 'application/json',
                 'accept': 'application/json',
                 'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
               },
             });
           //   console.log(response)
           if (response.ok) {
               const data1 = await response.json();
               setLoadingM(false)
               if(data1.data.length==0){
                   sethost([])
               setHostName("")
               setHostLocation("")
               setHostActivate(0)
                   setMsgError(capitalizeFirstLetter(lang[languaje]['msgIpNoExiste']))
                   setIpValid(false)
               }else{
                   setIpValid(true)

               }
               sethost(data1.data)
               setDisabled(true)
           } else {
               const data1 = await response.json();
               throw new Error('Error en la solicitud');
           }
       } catch (error) {
            console.error(error);
          }
        };

        fetchDataPost();
    }
    const changeOption=(option,index)=>{
        setCisData((prevState)=>{
            return {
                ...prevState,
                ['tech_id']:option.value===""?0:(parseInt(option.value))
            }
            
        })
        // setCisRelation(option.value)
    }
    const [fecha, setDate] = useState('2023-09-28')
    const validateIp= (ip) => {
        const ipRegex = /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
        let result = ipRegex.test(ip);
        if(result){
            buscar_host(ip)
        }else{
            setHostLocation("")
            setMsgError(capitalizeFirstLetter(lang[languaje]['ipNoValida']))
            sethost([])
                setHostName("")
                setHostLocation("")
                setHostActivate(0)
        }
        return result;
    };
    const [resultList,setResultList]=useState([])
    const handleSearchHost=(e)=>{
      
      const term = e.target.value;
      const {name,value}=e.target
      if(name=="ip"){
          setCisData((prevState)=>{
              return {
                  ...prevState,
                  ['ip']:value
              }
              
          })
      }
      // console.log(value)
      // setInputIP(value)
      setIpValid(validateIp(value))
      
      const filteredResults = devices.data.hosts.filter((item) => {
          
          return Object.entries(item).some(([key, value]) => {
            if (key === 'ip' || key=== 'Host') {
              return String(value).toLowerCase().includes(term.toLowerCase());
            }
            return false; // Si no es el atributo 'ip', retorna falso para continuar buscando en otros atributos
          });
        });
     
        setResultList(filteredResults)
    }

    //   console.log(resultList)
    const handleSelected=(element)=>{
        setIpValid(validateIp(element.ip))
        setCisData((prevState)=>{
            return {
                ...prevState,
                ['ip']:element.ip
            }
            
        })
        setListSearchIP(false)
    }
    const reqField=()=>{
        return(
          <p className='reqField-gs'>
            *
          </p>
        )
      }
    const closeListSearch=()=>{
        setListSearchIP(false)
    }
    const {software_name,message}=cisData;
    return(
        <div className="modal-user-content">
            <div className='card-modal-gs modal-verificate'>
                <div className='head-card-modal-gs'>
                    <div className='title-head-card-modal-gs'>
                        {capitalizeFirstLetter(lang[languaje]['solicitar'])+' Software'}
                    </div>
                </div>
                <div className='content-card-modal-gs' style={{overflowY: 'scroll',scrollbarWidth: 'thin'}}>
                
                                    <div className="form-GS-box"> 
                                    
                                  
                                    
                                    
                                   
                                    
                                    <div className="user-box-GS" style={{height:'30%'}}>
                                    <input required name="software_name"  type="text" value={software_name}
                                    onChange={handleChange} />
                                        <label className='label-GS' style={{top: '-10%'}}>{capitalizeFirstLetter(lang[languaje]['nombre'])}{(software_name=="")?reqField():''}</label>
                                        {
                                            // (name==="" || nombreIsValid)?'':<span className='form-msg-error'> Nombre no valido</span>
                                        }
                                        
                                    </div>
                                    <div className="user-box-GS" style={{height:'40%'}}>
                                    {/* <input required name="date"  type="datetime-local" value={date}
                                    onChange={handleChange} />
                                        <label className='label-cis active' >Fecha de ejecución</label> */}
                                        <input required name="message"  type="text" value={message}
                                    onChange={handleChange}  />
                                        <label className='label-GS  ' style={{top: '-5%'}}>{capitalizeFirstLetter(lang[languaje]['descripcion'])}{(message=="")?reqField():''}</label>
                                        {
                                            // (name==="" || nombreIsValid)?'':<span className='form-msg-error'> Nombre no valido</span>
                                        }
                                        
                                    </div>
                                   
                                    
                                                      
                                    <div className="user-box-GS" style={{height:'30%'}}>
                                        {
                                            (loading)?<LoadSimple></LoadSimple>
                                            :
                                            <>
                                            <Action disabled={false} origen='Cancelar' titulo={capitalizeFirstLetter(lang[languaje]['cancelar'])}  action={closCreateCisModal}/>
                                            <Action disabled={disabled} origen='Azul' titulo={capitalizeFirstLetter(lang[languaje]['solicitar'])}  action={Registrar}/>
                                            </>
                                        }
                                            
                                    {
                                        // (registerIsValid && data.message!=="User deleted successfully")?<span className='form-msg-ok'>Usuario registrado correctamente</span>:''
                                    }
                                        
                                    </div>
                                </div>
                </div>
                </div>
        </div>
    )
}

export default ModalCreateCis